<template>
  <div id="app">
    <keep-alive>
      <router-view class="us-view us-gradual" v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view class="us-view us-gradual" v-if="!$route.meta.keepAlive" />
    <FooterNav v-if="$route.meta.hasFooterNav" />
  </div>
</template>

<script>
import FooterNav from './views/Home/components/FooterNav'
export default {
  name: 'App',
  components: {
    FooterNav
  },
  data: () => ({
    enterActiceClass: '',
    leaveActiveClass: '',
    activeBtn: 1,
    timeout: null,
    errorTokenCount: 0,
    timeout2: null,
    initFirst: true
  }),
  watch: {
    $route(to, from) {
      const that = this
      const isBack = that.$router.isBack
      // console.log('isBack', isBack);
      if (isBack) {
        that.enterActiceClass = 'animated fadeIn'
        that.leaveActiveClass = 'animated fadeOutRight'
      } else {
        that.enterActiceClass = 'animated fadeInRight'
        that.leaveActiveClass = 'animated fadeOutLeft'
      }

      // that.$router.isBack = false
    }
  },
  methods: {
    // 检查用户token任务
    async checkTokenTask() {
      var that = this;

      if (that.timeout) {
        window.clearTimeout(that.timeout);
      }

      if (!that.$AppHelper.authed) {
        that.timeout = setTimeout(that.checkTokenTask, 1 * 1000);
        return;
      }

      var success = await that.checkToken();

      that.errorTokenCount = success ? 0 : that.errorTokenCount + 1;

      if (that.errorTokenCount > that.$AppHelper.tokenErrMaxCount) {
        that.errorTokenCount = 0;
        // 可以继续获取token, 3秒后继续检查
        that.timeout = setTimeout(that.checkTokenTask, 10 * 1000);
        return;
      }

      that.timeout = setTimeout(that.checkTokenTask, 10 * 1000);
    },
    // 检查用户token
    async checkToken() {
      var that = this

      if (that.initFirst) {
        const strToken = that.$route.query.token
        const strExpire = that.$route.query.expire
        if (!strToken && strToken === '' && !strExpire && strExpire === '') {
          const expire = this.$moment(strExpire).format('YYYY-MM-DD HH:mm:ss')
          const token = this.$moment(strExpire).format('YYYY-MM-DD HH:mm:ss')
          that.$AppHelper.setUserTokenInfo({ Token: token, Expire: expire })
        }
        that.initFirst = false
      }

      var tokenInfo = that.$AppHelper.getUserTokenInfo();

      var expiry = that.$AppHelper.tokenExpiry;

      if (tokenInfo.Token === '') {
        console.log('token为空, 拿新token.');
        var pnts = await that.$AppHelper.pullNewUserToken()
        return pnts
      }

      var fromTime = that.$moment(tokenInfo.Expire)

      var dura = fromTime.diff(that.$moment(), 'minutes')
      // console.log('fromTime', fromTime.format('YYYY-MM-DD HH:mm:ss'));
      // console.log('dura', dura);

      // 剩余5分钟就算过期了
      if (dura - 5 <= 0) {
        console.log('token过期了.' + that.timeout + '/' + fromTime.format('YYYY-MM-DD HH:mm:ss') + '/' + that.$moment().format('YYYY-MM-DD HH:mm:ss'));
        var success = await that.changeUserToken(expiry);
        // 换不了就重新拉取
        if (!success) {
          success = await that.$AppHelper.pullNewUserToken()
        }
        return success
      }
    },
    // 更改用户token
    async changeUserToken(expiry) {
      var that = this
      var res = await that.$api.gzh.changeUserToken({ expiry: expiry });
      if (!res.success) {
        // console.log('更改用户token失败了.');
        return false;
      }
      // console.log('change.token.data', res.data);
      that.$AppHelper.setUserTokenInfo(res.data);
      return true;
    },
    // 定时提交当前用户浏览的页面记录
    async submitBrowseHistTask() {
      var that = this;
      if (that.timeout2) {
        window.clearTimeout(that.timeout2);
      }
      await that.$AppHelper.submitBrowseHist(that.$route)
      that.timeout2 = setTimeout(that.submitBrowseHistTask, 10 * 1000);
    }
  },
  mounted() {
    var that = this
    that.checkTokenTask()
    that.submitBrowseHistTask()
  },
  destroyed() {
    var that = this
    if (that.timeout) {
      window.clearTimeout(that.timeout);
    }
    if (that.timeout2) {
      window.clearTimeout(that.timeout2);
    }
  }
};
</script>

<style scoped>

#app{
  color:#303133;
}

.us-gradual {
  -webkit-animation: fadeIn 0.4s;
}

@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  25% {
    opacity: 0.25;
  }
  50% {
    opacity: 0.5;
  }
  70% {
    opacity: 0.7;
  }
  100% {
    opacity: 1;
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  25% {
    opacity: 0.25;
  }
  50% {
    opacity: 0.5;
  }
  70% {
    opacity: 0.7;
  }
  100% {
    opacity: 1;
  }
}

</style>
